import React from "react";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Avatar from "@mui/material/Avatar";
import Typography from "@mui/material/Typography";
import { CardActionArea } from "@mui/material";
import Adepeju from "../../../assets/shortlist_22/adepeju.jpg";
import Busari from "../../../assets/shortlist_22/busari.jpg";
import Kemi from "../../../assets/shortlist_22/kemi.jpg";
import Oladiwura from "../../../assets/shortlist_22/oladiwura.jpg";

const obyNominees = [
  {
    name: "Adepeju Jaiyeoba",
    title: "Brown Button Foundation",
    imgpath: Adepeju,
    story:
      "Brown Button Foundation is a registered non-government-organization (NGO) working to improve maternal health care in Nigeria by providing maternal health care services in rural regions and slums.",
  },
  {
    name: "Busari Bisayo",
    title: " Project One",
    imgpath: Busari,
    story:
      "Project One is a NGO created for the sole purpose promotion of citizen appreciation building sublime lives and instilling the right leadership, political values for a national development through political education",
  },
  {
    name: "Dr Kemi DaSilva Ibru ",
    title: "WARIF",
    imgpath: Kemi,
    story:
      "Women at Risk International Foundation (WARIF) is a non-profit organization incorporated in response to the high incidence of sexual violence, rape and human trafficking occurring amongst young girls and women across Nigeria and Africa.",
  },
  {
    name: "Oladiwura Oladepo",
    title: "Tech4Dev",
    imgpath: Oladiwura,
    story:
      "Technology for Social Change and Development Initiative (Tech4Dev) is a non-profit social enterprise established in 2016 that creates access to decent work and opportunities for Africans through digital skills empowerment and advocacy.",
  },
];

const ObyNominees = () => {
  return (
    <Grid item xs={12} md={12} marginTop={{ xs: "10%", sm: "1%" }}>
      <Typography
        variant={"h5"}
        fontWeight={400}
        paddingBottom={"2%"}
        color={"#049593"}
      >
        Oby Ezekwesili Award for Women Advocacy (Shortlisted Nominees)
      </Typography>
      <Grid item xs={12} md={12} display={"flex"} flexWrap={"wrap"}>
        {obyNominees.map((nominate, index) => {
          const { name, title, imgpath, story } = nominate;
          return (
            <Grid
              key={index}
              item
              xs={12}
              md={3}
              marginBottom={{ xs: "7%", sm: "2%" }}
            >
              <Card
                sx={{
                  maxWidth: 260,
                  height: "100%",
                  borderTop: "10px solid #D7A036",
                }}
              >
                <CardActionArea>
                  <CardContent>
                    <Avatar
                      alt={name}
                      src={imgpath}
                      sx={{ width: 126, height: 126 }}
                    />
                    <Typography
                      gutterBottom
                      variant="h6"
                      color={"#004165"}
                      component="div"
                      textAlign={"center"}
                    >
                      {name}
                    </Typography>
                    <Typography
                      variant="body2"
                      fontWeight={700}
                      color="#049593"
                      paragraph
                      textAlign={"center"}
                    >
                      {title}
                    </Typography>
                    <Typography
                      paragraph
                      variant="body2"
                      fontWeight={400}
                      color="#4f4f4f"
                      textAlign={"center"}
                    >
                      {story}
                    </Typography>
                  </CardContent>
                </CardActionArea>
              </Card>
            </Grid>
          );
        })}
      </Grid>
    </Grid>
  );
};

export default ObyNominees;
